import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { Image } from './image';

export class DefectDetail {
    constructor(doc)
    {
		this.label = null;
		this.completionReportNewDefectIndicator = null;
		this.defectComponentLabelType = null;
		this.defectComponentLabelTypeOtherDescription = null;
		this.defectItemAffectsSoundnessStructuralIntegrityIndicator = null;
		this.defectItemDescription = null;
		this.defectItemEstimatedCostToRepairAmount = null;
		this.defectItemLocationType = null;
		this.defectItemLocationTypeOtherDescription = null;
		this.defectItemRecommendedActionCompletedIndicator = null;
		this.defectItemRecommendedActionCompletionDescription = null;
		this.defectItemRecommendedActionInspectionDate = null;
		this.defectItemRecommendedActionType = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.completionReportNewDefectIndicator = x.getBooleanElement(doc, "./ns:CompletionReportNewDefectIndicator");
		this.defectComponentLabelType = x.getStringElement(doc, "./ns:DefectComponentLabelType");
		this.defectComponentLabelTypeOtherDescription = x.getStringElement(doc, "./ns:DefectComponentLabelTypeOtherDescription");
		this.defectItemAffectsSoundnessStructuralIntegrityIndicator = x.getBooleanElement(doc, "./ns:DefectItemAffectsSoundnessStructuralIntegrityIndicator");
		this.defectItemDescription = x.getStringElement(doc, "./ns:DefectItemDescription");
		this.defectItemEstimatedCostToRepairAmount  = x.getMISMOAmountElement(doc, "./ns:DefectItemEstimatedCostToRepairAmount");
		this.defectItemLocationType = x.getStringElement(doc, "./ns:DefectItemLocationType");
		this.defectItemLocationTypeOtherDescription = x.getStringElement(doc, "./ns:DefectItemLocationTypeOtherDescription");
		this.defectItemRecommendedActionCompletedIndicator = x.getBooleanElement(doc, "./ns:DefectItemRecommendedActionCompletedIndicator");
		this.defectItemRecommendedActionCompletionDescription = x.getStringElement(doc, "./ns:DefectItemRecommendedActionCompletionDescription");
		this.defectItemRecommendedActionInspectionDate = x.getMISMODateElement(doc, "./ns:DefectItemRecommendedActionInspectionDate");
		this.defectItemRecommendedActionType = x.getStringElement(doc, "./ns:DefectItemRecommendedActionType");
   }
}

export class Defect {
    constructor(doc)
    {
		this.label = null;
		this.defectDetail = null;
		this.images = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:DEFECT_DETAIL");
		if (node !== null)
				this.defectDetail = new DefectDetail(node);
		nodes = x.selectNodes(doc, "./ns:IMAGES/ns:IMAGE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.images.push(new Image(xn));
			});
		}
  }

 GetComponentLabelType() {
    return h.descriptionOrOther(
        this.defectDetail.defectComponentLabelType,
        this.defectDetail.defectComponentLabelTypeOtherDescription
    );
	}

 GetLocationType() {
    return h.descriptionOrOther(
        this.defectDetail.defectItemLocationType,
        this.defectDetail.defectItemLocationTypeOtherDescription
    );
	}

 GetImages() {
    let tag = "Apparent Defects, Damages, Deficiencies -\n";
    const images = [];

    if (!this.images) return images;

    this.images.forEach(image => {
        // Create a new image object to avoid modifying the original
        const processedImage = {...image};
        tag = `${tag}${this.GetComponentLabelType()}`;

        // Add image description with proper spacing
        if (image.imageCaptionCommentDescription) {
            tag += ` - ${image.imageCaptionCommentDescription}`;
        }

        processedImage.imageSourceCaption = tag;
        images.push(processedImage);
    });

    return images;
	}
}

export class PropertyDefectSummary {
    constructor(doc)
    {
		this.label = null;
		this.costToRepairType = null;
		this.defectCostToRepairTotalAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.costToRepairType = x.getStringElement(doc, "./ns:CostToRepairType");
		this.defectCostToRepairTotalAmount  = x.getMISMOAmountElement(doc, "./ns:DefectCostToRepairTotalAmount");
   }
}

export class PropertyDefect {
    constructor(doc)
    {
		this.label = null;
		this.defects = [];
		this.propertyDefectSummary = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:DEFECTS/ns:DEFECT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.defects.push(new Defect(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:PROPERTY_DEFECT_SUMMARY");
		if (node !== null)
				this.propertyDefectSummary = new PropertyDefectSummary(node);
   }

	GetDefectsByLabels(tags) {
    const defects = [];
    if (!tags) return defects;
    if (this.defects.length === 0) return defects;
    for (const defect of this.defects) {
        if (tags.includes(defect.label)) defects.push(defect);
    }
    return defects;
	}

	GetDefectsByArcRole(arcrole, label) {
		let rels = global.ptr.relationships.GetRelationshipsTo(arcrole, label);
		let defects = global.ptr.subProp.propertyDefect.GetDefectsByLabels(rels);
		return defects;
	}

	GetNewDefects(bNew) {
			const defects = [];
			if (!this.defects) return defects;
			for (const defect of this.defects) {
					if (defect.defectDetail.completionReportNewDefectIndicator === bNew) defects.push(defect);
			}
			return defects;
		}

	GetDefectByLabel(label) {
			if (!this.defects) return null;
			for (const defect of this.defects) {
					if (label === defect.label) return defect;
			}
			return null;
		}

	GetDefectsImages() {
			if (!this.defects) return null;
			const images = [];
			for (const defect of this.defects) {
					const defImages = defect.getImages();
					for (const img of defImages) {
							const bNew = defect.defectDetail.completionReportNewDefectIndicator;
							if (bNew !== null) {
									if (!bNew || bNew === false) {
											img.imageSourceCaption = `Itemized List of Repairs - ${defect.GetComponentLabelType()} - ${img.imageCaptionCommentDescription}`;
									} else {
											img.imageSourceCaption = `New Observed Items for Repair - ${defect.GetComponentLabelType()} - ${img.imageCaptionCommentDescription}`;
									}
							}
					}
					images.push(...defImages);
			}
			return images;
		}

	GetRecommended() {
    const defects = [];
    if (!this.defects) return defects;
    for (const defect of this.defects) {
        if (defect.defectDetail.defectItemRecommendedActionType !== "None") defects.push(defect);
    }
    return defects;
	}
}

